import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, Palette, TrendingUp } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import Header from '../components/Header';
import Footer from '../components/Footer';

const RoleSelection = () => {
  const navigate = useNavigate();

  const roles = [
    {
      id: 'institutional',
      title: 'Institutional Customer',
      description: 'Register your company for bulk orders and special pricing',
      icon: Building2,
      color: 'bg-red-600',
      features: ['Bulk discounts', 'GST billing', 'Priority support', 'Custom orders']
    },
    {
      id: 'designer',
      title: 'Product Designer',
      description: 'Submit your designs and earn lifetime royalties',
      icon: Palette,
      color: 'bg-red-600',
      features: ['Submit designs', 'Lifetime royalties', 'Designer credit', 'Global reach']
    },
    {
      id: 'investor',
      title: 'Micro Investor',
      description: 'Invest in inventory or molds and earn returns',
      icon: TrendingUp,
      color: 'bg-red-600',
      features: ['Low entry barrier', 'Minimum 12% returns', 'Real-time tracking', 'Diversified portfolio']
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <div className="container mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Choose Your Role</h1>
          <p className="text-xl text-gray-600">Join Youseful.shop ecosystem as</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {roles.map((role) => {
            const Icon = role.icon;
            return (
              <Card key={role.id} className="p-6 hover:shadow-xl transition-shadow">
                <div className={`w-16 h-16 ${role.color} rounded-lg flex items-center justify-center mb-4`}>
                  <Icon className="h-8 w-8 text-white" />
                </div>
                <h2 className="text-2xl font-bold mb-3">{role.title}</h2>
                <p className="text-gray-600 mb-6">{role.description}</p>
                
                <div className="space-y-2 mb-6">
                  {role.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center text-sm">
                      <div className="w-1.5 h-1.5 bg-red-600 rounded-full mr-2"></div>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>

                <Button 
                  className={`w-full ${role.color} hover:opacity-90`}
                  onClick={() => navigate(`/register/${role.id}`)}
                >
                  Register as {role.title.split(' ')[0]}
                </Button>
              </Card>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">Already a consumer?</p>
          <Button variant="outline" onClick={() => navigate('/')}>
            Continue Shopping
          </Button>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default RoleSelection;
